import { useLingui } from '@lingui/react';

import { locales } from '../constants/locales';

/**
 * Read-only access to the currently active locale.
 *
 * Lives outside the TanStack Router match tree on purpose: hooks like
 * `useFormatDate` are called from components rendered all over the app, and
 * pulling in `useParams`/`useLocation` from the route-aware
 * `useLanguageSwitcher` made every formatter throw an "Invariant failed" error
 * during route invalidation races (e.g. delete-account → /sign-in redirect
 * while the AccountSettings subtree was still in the React tree).
 *
 * Use this hook for *reading* the locale. Use `useLanguageSwitcher` only inside
 * the locale-switch UI (Footer, Sidebar) where switching is actually needed.
 */
export const useCurrentLocale = () => {
  const { i18n } = useLingui();
  return i18n.locale as keyof typeof locales;
};
